export const BackgroundRequest_TYPE_REQUEST = "BackgroundRequest_TYPE_REQUEST";
export const BackgroundRequest_TYPE_SUCCESS = "BackgroundRequest_TYPE_SUCCESS";
export const BackgroundRequest_TYPE_FAILURE = "BackgroundRequest_TYPE_FAILURE";
